<template>
  <div>
    <!-- Generales -->
    <h6 class="mt-2">Generales</h6>
    <b-card class="mb-2 p-2">
      <b-row>
        <b-col md="3">
          <b-form-group label="Sexo objetivo">
            <b-form-select v-model="rules.generales.sexo" :options="sexoOpts"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Edad mínima">
            <b-form-input type="number" min="0" v-model.number="rules.generales.edadMin"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Edad máxima">
            <b-form-input type="number" min="0" v-model.number="rules.generales.edadMax"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <b-form-group label="Notas al paciente">
            <b-form-textarea rows="2" v-model.trim="rules.generales.notasPaciente" placeholder="Indicaciones importantes para el paciente"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <!-- Vigencia y Caducidad -->
    <h6 class="mt-2">Vigencia y caducidad</h6>
    <b-card class="mb-2 p-2">
      <b-form-checkbox v-model="rules.caducidad.duracionEnabled">Duración/vence en fecha fija</b-form-checkbox>
      <b-row v-if="rules.caducidad.duracionEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="Vence en fecha fija (opcional)">
            <b-form-input type="date" v-model="rules.caducidad.venceEn"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.caducidad.activacionDiferidaEnabled">Activación diferida</b-form-checkbox>
      <b-row v-if="rules.caducidad.activacionDiferidaEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="Usable desde">
            <b-form-input type="date" v-model="rules.caducidad.activacionDesde"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.caducidad.congelamientoEnabled">Congelamiento permitido</b-form-checkbox>
      <b-row v-if="rules.caducidad.congelamientoEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="Máx. días de congelamiento">
            <b-form-input type="number" min="0" v-model.number="rules.caducidad.congelamientoMaxDias"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.caducidad.blackoutEnabled">Fechas bloqueadas del servicio</b-form-checkbox>
      <div v-if="rules.caducidad.blackoutEnabled" class="mt-1">
        <b-row>
          <b-col md="3">
            <b-form-group label="Desde">
              <b-form-input type="date" v-model="draft.blackout.desde"/>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Hasta">
              <b-form-input type="date" v-model="draft.blackout.hasta"/>
            </b-form-group>
          </b-col>
          <b-col md="2" class="d-flex align-items-end">
            <b-button size="sm" variant="primary" @click="addBlackout" :disabled="!canAddBlackout">Agregar</b-button>
          </b-col>
        </b-row>
        <b-table small bordered striped :items="rules.caducidad.blackouts" :fields="fieldsBlackouts">
          <template #cell(acciones)="{ index }">
            <div class="text-right">
              <b-button size="sm" variant="danger" @click="removeBlackout(index)"><i class="fas fa-times"/></b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>

    <!-- Canales de agendamiento -->
    <h6>Canales de agendamiento</h6>
    <b-card class="mb-2 p-2">
      <b-row>
        <b-col md="3" sm="4" cols="6">
          <b-form-checkbox v-model="rules.canales.web">Web</b-form-checkbox>
        </b-col>
        <b-col md="3" sm="4" cols="6">
          <b-form-checkbox v-model="rules.canales.sucursal">Sucursal</b-form-checkbox>
        </b-col>
        <b-col md="3" sm="4" cols="6">
          <b-form-checkbox v-model="rules.canales.callCenter">Call-center</b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>

    

    <!-- Segmentación y requisitos -->
    <h6>Segmentación y requisitos</h6>
    <b-card class="mb-2 p-2">
      <b-row>
        <b-col md="3" sm="6">
          <b-form-checkbox v-model="rules.segmentacion.embarazo">Restricción por embarazo</b-form-checkbox>
        </b-col>
        <b-col md="3" sm="6">
          <b-form-checkbox v-model="rules.segmentacion.terceraEdad">Restricción tercera edad</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <h6 class="mb-1">Requisitos médicos por servicio</h6>
      <b-row>
        <b-col md="4" v-for="k in categoriasKeys" :key="'req-'+k">
          <b-form-checkbox v-model="rules.requisitos.ordenMedicaPorServicio[k]">
            {{ labelsCategorias[k] }}: Requiere orden médica
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <h6 class="mb-1">Precondiciones</h6>
      <b-row>
        <b-col md="3" sm="6">
          <b-form-checkbox v-model="rules.requisitos.precondiciones.ayuno">Ayuno</b-form-checkbox>
        </b-col>
        <b-col md="3" sm="6">
          <b-form-checkbox v-model="rules.requisitos.precondiciones.chequeoCardiologo">Chequeo de cardiólogo</b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>

    <!-- Sedes elegibles -->
    <h6>Sedes elegibles</h6>
    <b-card class="mb-2 p-2">
      <b-form-group description="Seleccione los establecimientos donde aplica el paquete">
        <b-form-checkbox-group v-model="rules.sedesElegibles" :options="sedesOpts" value-field="value" text-field="text" switches />
      </b-form-group>
    </b-card>

    <!-- Formas de pago y reembolsos -->
    <h6>Formas de pago y reembolsos</h6>
    <b-card class="mb-2 p-2">
      <h6 class="mb-1">Formas de pago permitidas</h6>
      <b-row>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.pagos.formas.efectivo">Efectivo</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.pagos.formas.tarjeta">Tarjeta crédito</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.pagos.formas.financiamiento">Financiamiento</b-form-checkbox></b-col>
      </b-row>
      <hr>
      <h6 class="mb-1">Reembolso</h6>
      <b-row>
        <b-col md="3">
          <b-form-group label="Devolución dentro de (días)">
            <b-form-input type="number" min="0" v-model.number="rules.pagos.reembolso.diasLimite"/>
          </b-form-group>
        </b-col>
        <b-col md="4" class="d-flex align-items-center">
          <b-form-checkbox v-model="rules.pagos.reembolso.bloquearCancelacionConUso">Bloquear cancelación si ya hubo uso</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="Reembolso parcial (%): prorrateo por uso">
            <b-form-input type="number" min="0" max="100" v-model.number="rules.pagos.reembolso.parcialPorcentaje"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Retención administrativa (%)">
            <b-form-input type="number" min="0" max="100" v-model.number="rules.pagos.reembolso.retencionAdministrativaPct"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- Reglas por servicio -->
    <h6>Reglas por servicio</h6>
    <b-card class="mb-2 p-2">
      <h6 class="mb-1">Imágenes</h6>
      <b-row>
        <b-col md="4">
          <b-form-checkbox v-model="rules.serviciosExtra.imagenes.solicitarSedacion">Solicitar sedación</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <h6 class="mb-1">Laboratorio</h6>
      <b-row>
        <b-col md="6">
          <b-form-group label="Limitar familias (agregar y listar)">
            <div class="d-flex">
              <b-form-input class="mr-2" v-model.trim="draft.familiaLab" placeholder="Nombre de familia"/>
              <b-button size="sm" variant="primary" @click="addFamiliaLab" :disabled="!canAddFamiliaLab">Agregar</b-button>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table small bordered striped :items="rules.serviciosExtra.laboratorio.familiasLimitadas" :fields="fieldsFamiliasLab">
        <template #cell(familia)="{ item }">
          <span>{{ item.familia }}</span>
        </template>
        <template #cell(acciones)="{ index }">
          <div class="text-right">
            <b-button size="sm" variant="danger" @click="removeFamiliaLab(index)"><i class="fas fa-times"/></b-button>
          </div>
        </template>
      </b-table>
      <hr>
      <h6 class="mb-1">Terapias</h6>
      <b-row>
        <b-col md="4">
          <b-form-group label="Máx. sesiones semanales">
            <b-form-input type="number" min="0" v-model.number="rules.serviciosExtra.terapias.maxSesionesSemanales"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Caducidad por sesión (días)">
            <b-form-input type="number" min="0" v-model.number="rules.serviciosExtra.terapias.caducidadPorSesionDias"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- Beneficios y recordatorios -->
    <h6>Beneficios agregados</h6>
    <b-card class="mb-2 p-2">
      <b-row>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.beneficios.parkingGratis">Parking gratis</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.beneficios.salaVIP">Sala VIP</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.beneficios.bebidas">Bebidas</b-form-checkbox></b-col>
      </b-row>
    </b-card>

    <h6>Recordatorios</h6>
    <b-card class="mb-4 p-2">
      <b-row>
        <b-col md="3">
          <b-form-group label="Frecuencia (días)">
            <b-form-input type="number" min="0" v-model.number="rules.recordatorios.frecuenciaDias"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.recordatorios.canales.sms">SMS</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.recordatorios.canales.email">Email</b-form-checkbox></b-col>
        <b-col md="3" sm="6"><b-form-checkbox v-model="rules.recordatorios.canales.whatsapp">WhatsApp</b-form-checkbox></b-col>
      </b-row>
    </b-card>

    <!-- Usos y restricciones -->
    <h6>Usos y restricciones</h6>
    <b-card class="mb-2 p-2">
      <b-form-checkbox v-model="rules.usos.topePorServicioEnabled">Tope de usos por servicio</b-form-checkbox>
      <div v-if="rules.usos.topePorServicioEnabled" class="mb-2">
        <b-row>
          <b-col md="3" v-for="k in categoriasKeys" :key="k">
            <b-form-group :label="labelsCategorias[k]">
              <b-form-input type="number" min="0" v-model.number="rules.usos.topePorCategoria[k]"/>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <b-form-checkbox v-model="rules.usos.frecuenciaMinimaEnabled">Frecuencia mínima entre usos</b-form-checkbox>
      <b-row v-if="rules.usos.frecuenciaMinimaEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="Días entre usos">
            <b-form-input type="number" min="0" v-model.number="rules.usos.frecuenciaMinimaDias"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex align-items-center">
        <b-form-checkbox v-model="rules.usos.concurrenciaEnabled">Concurrencia</b-form-checkbox>
        <span class="ml-2" title="Limitar servicios simultáneos por día/visita">?</span>
      </div>

      <b-form-checkbox v-model="rules.usos.transferibleEnabled">Transferible a familiares</b-form-checkbox>
      <b-form-checkbox v-model="rules.usos.compartibleEnabled">Compartible entre personas</b-form-checkbox>
    </b-card>

    <!-- Precios y promociones -->
    <h6>Precios y promociones</h6>
    <b-card class="mb-2 p-2">
      <b-form-checkbox v-model="rules.precios.dinamicoEnabled">Precio dinámico por temporada</b-form-checkbox>
      <b-row v-if="rules.precios.dinamicoEnabled" class="mt-1">
        <b-col md="3">
          <b-form-group label="Desde">
            <b-form-input type="date" v-model="rules.precios.dinamicoDesde"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Hasta">
            <b-form-input type="date" v-model="rules.precios.dinamicoHasta"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="% Descuento">
            <b-form-input type="number" min="0" max="100" v-model.number="rules.precios.dinamicoDescuentoPct"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.precios.diasEspecialesEnabled">Días especiales</b-form-checkbox>
      <div v-if="rules.precios.diasEspecialesEnabled" class="mt-1">
        <b-row>
          <b-col md="3">
            <b-form-group label="Desde">
              <b-form-input type="date" v-model="draft.diaEsp.desde"/>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Hasta">
              <b-form-input type="date" v-model="draft.diaEsp.hasta"/>
            </b-form-group>
          </b-col>
          <b-col md="2" class="d-flex align-items-end">
            <b-button size="sm" variant="primary" @click="addDiaEspecial" :disabled="!canAddDiaEsp">Agregar</b-button>
          </b-col>
        </b-row>
        <b-table small bordered striped :items="rules.precios.diasEspeciales" :fields="fieldsDiasEsp">
          <template #cell(acciones)="{ index }">
            <div class="text-right">
              <b-button size="sm" variant="danger" @click="removeDiaEspecial(index)"><i class="fas fa-times"/></b-button>
            </div>
          </template>
        </b-table>
      </div>

      <b-form-checkbox v-model="rules.precios.volumenEnabled">Precio por volumen</b-form-checkbox>
      <div v-if="rules.precios.volumenEnabled" class="mt-1">
        <b-row>
          <b-col md="3">
            <b-form-group label=">= Cantidad">
              <b-form-input type="number" min="1" v-model.number="draft.volumen.cantidadMin"/>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="% Descuento">
              <b-form-input type="number" min="0" max="100" v-model.number="draft.volumen.descuentoPct"/>
            </b-form-group>
          </b-col>
          <b-col md="2" class="d-flex align-items-end">
            <b-button size="sm" variant="primary" @click="addVolumen" :disabled="!canAddVolumen">Agregar</b-button>
          </b-col>
        </b-row>
        <b-table small bordered striped :items="rules.precios.volumenEscalas" :fields="fieldsVolumen">
          <template #cell(acciones)="{ index }">
            <div class="text-right">
              <b-button size="sm" variant="danger" @click="removeVolumen(index)"><i class="fas fa-times"/></b-button>
            </div>
          </template>
        </b-table>
      </div>

      <b-form-checkbox v-model="rules.precios.ventaCruzadaEnabled">Venta cruzada</b-form-checkbox>
      <b-row v-if="rules.precios.ventaCruzadaEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="% Descuento">
            <b-form-input type="number" min="0" max="100" v-model.number="rules.precios.ventaCruzadaDescuentoPct"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Paquete relacionado">
            <b-form-input v-model.trim="rules.precios.ventaCruzadaPaquete" placeholder="Nombre o código del paquete"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.precios.referralEnabled">Referral</b-form-checkbox>
      <b-row v-if="rules.precios.referralEnabled" class="mt-1">
        <b-col md="4">
          <b-form-group label="Tipo de recomendación">
            <b-form-select v-model="rules.precios.referralTipo" :options="referralOpts"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-checkbox v-model="rules.precios.convenioEnabled">Empresa/Convenio</b-form-checkbox>
      <b-row v-if="rules.precios.convenioEnabled" class="mt-1">
        <b-col md="6">
          <b-form-group label="Convenio">
            <b-form-select v-model="rules.precios.convenio" :options="convenioOpts"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
  
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormCheckbox, BCard, BTable, BButton, BFormCheckboxGroup } from 'bootstrap-vue'
import { establecimientosService } from '@/views/administracion/services/establecimientosService'

export default {
  name: 'PaqReglas',
  components: { BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormCheckbox, BCard, BTable, BButton, BFormCheckboxGroup },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Object, required: true },
    categoriasKeys: { type: Array, required: true },
    labelsCategorias: { type: Object, required: true },
  },
  data () {
    return {
      draft: {
        blackout: { desde: null, hasta: null },
        diaEsp: { desde: null, hasta: null },
        volumen: { cantidadMin: null, descuentoPct: null },
        familiaLab: null,
      },
      fieldsBlackouts: [
        { key: 'desde', label: 'Desde' },
        { key: 'hasta', label: 'Hasta' },
        { key: 'acciones', label: 'Acciones', class: 'text-right' },
      ],
      fieldsDiasEsp: [
        { key: 'desde', label: 'Desde' },
        { key: 'hasta', label: 'Hasta' },
        { key: 'acciones', label: 'Acciones', class: 'text-right' },
      ],
      fieldsVolumen: [
        { key: 'cantidadMin', label: 'Cantidad >=' },
        { key: 'descuentoPct', label: '% Desc.' },
        { key: 'acciones', label: 'Acciones', class: 'text-right' },
      ],
      fieldsFamiliasLab: [
        { key: 'familia', label: 'Familia' },
        { key: 'acciones', label: 'Acciones', class: 'text-right' }
      ],
      
      referralOpts: [
        { value: 'paciente_existente', text: 'Paciente existente' },
        { value: 'empleado', text: 'Empleado' },
        { value: 'otro', text: 'Otro' },
      ],
      convenioOpts: [
        { value: null, text: 'Seleccionar…' },
        { value: 'corporativo_a', text: 'Corporativo A' },
        { value: 'corporativo_b', text: 'Corporativo B' },
      ],
      sedesOpts: [],
      sexoOpts: [
        { value: null, text: 'Indistinto' },
        { value: 'F', text: 'Femenino' },
        { value: 'M', text: 'Masculino' },
      ],
    }
  },
  computed: {
    rules: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    },
    canAddBlackout () {
      const d = this.draft.blackout
      return !!(d.desde && d.hasta)
    },
    canAddDiaEsp () {
      const d = this.draft.diaEsp
      return !!(d.desde && d.hasta)
    },
    canAddVolumen () {
      const v = this.draft.volumen
      return !!(v.cantidadMin && (v.descuentoPct || v.descuentoPct === 0))
    },
    canAddFamiliaLab () {
      return !!(this.draft.familiaLab && this.draft.familiaLab.trim())
    },
  },
  async mounted () {
    try {
      this.sedesOpts = await establecimientosService.getForSelect()
    } catch (e) {
      this.sedesOpts = []
    }
  },
  methods: {
    addBlackout () {
      const { desde, hasta } = this.draft.blackout
      if (!desde || !hasta) return
      this.rules.caducidad.blackouts = [...this.rules.caducidad.blackouts, { desde, hasta }]
      this.draft.blackout = { desde: null, hasta: null }
    },
    removeBlackout (idx) {
      this.rules.caducidad.blackouts.splice(idx, 1)
    },
    addDiaEspecial () {
      const { desde, hasta } = this.draft.diaEsp
      if (!desde || !hasta) return
      this.rules.precios.diasEspeciales = [...this.rules.precios.diasEspeciales, { desde, hasta }]
      this.draft.diaEsp = { desde: null, hasta: null }
    },
    removeDiaEspecial (idx) {
      this.rules.precios.diasEspeciales.splice(idx, 1)
    },
    addVolumen () {
      const { cantidadMin, descuentoPct } = this.draft.volumen
      if (!cantidadMin || descuentoPct == null) return
      this.rules.precios.volumenEscalas = [...this.rules.precios.volumenEscalas, { cantidadMin, descuentoPct }]
      this.draft.volumen = { cantidadMin: null, descuentoPct: null }
    },
    removeVolumen (idx) {
      this.rules.precios.volumenEscalas.splice(idx, 1)
    },
    addFamiliaLab () {
      const val = (this.draft.familiaLab || '').trim()
      if (!val) return
      this.rules.serviciosExtra.laboratorio.familiasLimitadas = [
        ...this.rules.serviciosExtra.laboratorio.familiasLimitadas,
        { familia: val },
      ]
      this.draft.familiaLab = null
    },
    removeFamiliaLab (idx) {
      this.rules.serviciosExtra.laboratorio.familiasLimitadas.splice(idx, 1)
    },
  }
}
</script>

<style scoped>
</style>
